import { Link } from 'react-router-dom';

const solucoes = [
  {
    titulo: 'Mobiliário corporativo',
    descricao: 'Estações, mesas, cadeiras, armários, recepções, salas de reunião e diretoria.',
    icon: 'ri-layout-5-line',
    to: '/produtos',
  },
  {
    titulo: 'Divisórias corporativas',
    descricao: 'Vidro, MDF, soluções mistas, privacidade, acústica e organização de ambientes.',
    icon: 'ri-command-line',
    to: '/divisorias',
  },
  {
    titulo: 'Carpetes corporativos',
    descricao: 'Carpete modular e soluções de piso para áreas empresariais.',
    icon: 'ri-layout-bottom-line',
    to: '/produtos',
  },
  {
    titulo: 'Soluções acústicas',
    descricao: 'Cabines, tratamentos e soluções para maior conforto sonoro.',
    icon: 'ri-sound-module-line',
    to: '/cabines-acusticas',
  },
  {
    titulo: 'Marcenaria corporativa',
    descricao: 'Peças e soluções sob medida integradas ao projeto.',
    icon: 'ri-ruler-line',
    to: '/marcenaria-corporativa',
  },
  {
    titulo: 'Entrega e montagem',
    descricao: 'Coordenação logística e implantação.',
    icon: 'ri-truck-line',
    to: '/turnkey',
  },
];

export default function SolucoesSection() {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-[1200px] mx-auto px-5 md:px-8">
        <div className="max-w-2xl mb-12 md:mb-16">
          <p className="text-[12px] md:text-[13px] font-semibold tracking-[0.28em] uppercase text-primary-500 mb-4">
            Soluções
          </p>
          <h2 className="text-foreground-950 text-[28px] md:text-[40px] font-semibold tracking-tight leading-tight">
            Um único parceiro para diferentes etapas do ambiente corporativo.
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {solucoes.map((solucao) => (
            <Link
              key={solucao.titulo}
              to={solucao.to}
              className="group bg-background-50 border border-background-200/70 rounded-2xl p-7 md:p-8 hover:border-primary-200 transition-colors duration-300"
            >
              <div className="flex items-start justify-between mb-6">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-50 text-primary-500">
                  <i className={`${solucao.icon} text-xl`}></i>
                </div>
                <i className="ri-arrow-right-up-line text-foreground-300 group-hover:text-primary-500 text-lg transition-colors duration-300"></i>
              </div>
              <h3 className="text-foreground-950 text-[18px] md:text-[20px] font-semibold tracking-tight mb-3">
                {solucao.titulo}
              </h3>
              <p className="text-foreground-500 text-[14px] md:text-[15px] leading-relaxed">
                {solucao.descricao}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}